module.exports = __webpack_public_path__ + "static/img/RedBag.c49bbb3.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/index/RedBag.png
// module id = 1168
// module chunks = 18